import(/* webpackMode: "eager", webpackExports: ["TemplatesClient"] */ "/app/src/app/templates/TemplatesClient.tsx");
